module.exports = __webpack_public_path__ + "img/icon17.7c676c6a.png";